// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"TK-z","smallCardRow":"UK-z","largeCardRow":"VK-z","productSearchRow":"WK-z","curatedRow":"XK-z"};